export const toAmount = value => {
  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : 0;
};
